module.exports = __webpack_public_path__ + "static/18-06bcdf14997edf6e14191536101b9025.jpg";